import React from 'react';
import PropTypes from 'prop-types';
import Accent from '../button/accent';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faClose,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';

import './styles.scss';

export const baseVariants = {
  danger: {
    className: 'banner--danger',
    icon: faCircleExclamation,
  },
  info: {
    className: 'banner--info',
    icon: faCircleInfo,
  },
  info2: {
    className: 'banner--info-2',
    icon: faCircleInfo,
  },
  info3: {
    className: 'banner--info-3',
    icon: faCircleInfo,
  },
  success: {
    className: 'banner--success',
    icon: faCircleCheck,
  },
  warning: {
    className: 'banner--warning',
    icon: faTriangleExclamation,
  },
  action: {
    className: 'banner--action',
    icon: faCircleInfo,
  }
};

export default function Banner({
  callToAction,
  className,
  content,
  extraVariants,
  icon,
  noIcon = false,
  show = true,
  title,
  variant,
  onClose,
}) {
  if (!show) {
    return null;
  }

  const variants = { ...baseVariants, ...extraVariants };
  const variantConfig = variants[variant] || variants.info;
  icon = icon || variantConfig?.icon;

  return (
    <div className={classNames('banner align-items-center', variantConfig?.className, className)}>
      {icon && !noIcon && <FontAwesomeIcon icon={icon} size="lg"/>}

      <div className="flex-fill">
        {title && (
          <div className="title pt-0">
            <b>{title}</b>
          </div>
        )}

        <div>
          {content}
        </div>
      </div>

      {callToAction &&
        <>
          <span>{callToAction.detailsText}</span>
          <Accent outlined onClick={callToAction.onClick}>
            {callToAction.buttonText}
          </Accent>
        </>
      }

      {onClose &&
        <FontAwesomeIcon
          aria-label="close"
          icon={faClose}
          role="button"
          onClick={onClose}
        />
      }
    </div>
  );
}

Banner.propTypes = {
  callToAction: PropTypes.shape({
    buttonText: PropTypes.string,
    onClick: PropTypes.func,
    detailsText: PropTypes.string
  }),
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  extraVariants: PropTypes.object,
  icon: PropTypes.object,
  noIcon: PropTypes.bool,
  show: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  variant: PropTypes.string,
  onClose: PropTypes.func,
};
